



















































import { Inject, Component, Vue } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { List } from '@/data/models/list.model';
import { Search } from '@/data/models/search.model';

@Component
export default class ListaList extends Vue {
	@Inject('CrudService') listeCrudService!: CrudService<List>;

	rows: List[] = [];
	advancedSearch: Search = new Search('selist');
	loading: boolean = false;

	constructor() {
		super();
	}

	loadListe() {
		this.listeCrudService
			.searchEntities(
				List,
				'selist',
				this.advancedSearch,
				this.advancedSearch.page
			)
			.then((results) => {
				this.rows = results;
			});
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadListe();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadListe();
	}

	beforeMount() {
		this.loadListe();
	}
}
